import { render, staticRenderFns } from "./GateImpacts.vue?vue&type=template&id=cd53ff6c&scoped=true"
import script from "./GateImpacts.vue?vue&type=script&lang=ts"
export * from "./GateImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53ff6c",
  null
  
)

export default component.exports